/**
 * Performance Configuration
 * Ottimizzazioni per ridurre il lavoro sul main thread
 * Basato su: https://developer.chrome.com/docs/lighthouse/performance/mainthread-work-breakdown
 */

window.PerformanceConfig = {
  // Configurazione Load More
  loadMore: {
    chunkSize: 5, // Prodotti processati per chunk (aumentato)
    idleTimeout: 16, // 60fps
    maxConcurrent: 2 // Max richieste AJAX simultanee
  },
  
  // Configurazione Lazy Loading
  lazyLoad: {
    rootMargin: '50px',
    threshold: 0.1,
    enableIntersectionObserver: true
  },
  
  // Configurazione Memory Management
  memory: {
    maxElementsInPool: 50,
    cleanupInterval: 30000, // 30 secondi
    enableGarbageCollection: true
  },
  
  // Configurazione Script Loading
  scripts: {
    deferNonCritical: true,
    useRequestIdleCallback: true,
    maxIdleTimeout: 2000
  },
  
  // Configurazione CSS
  css: {
    inlineCritical: true,
    deferNonCritical: true,
    enableContentVisibility: true
  },
  
  // Configurazione Monitoring
  monitoring: {
    enabled: true,
    logLevel: 'info', // 'debug', 'info', 'warn', 'error'
    trackMemory: true,
    trackTiming: true
  }
};

// Utility functions per le ottimizzazioni
window.PerformanceUtils = {
  // Debounce ottimizzato
  debounce: function(func, wait, immediate = false) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        timeout = null;
        if (!immediate) func(...args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func(...args);
    };
  },
  
  // Throttle ottimizzato
  throttle: function(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  },
  
  // RequestIdleCallback con fallback
  requestIdleCallback: function(callback, options = {}) {
    if ('requestIdleCallback' in window) {
      return window.requestIdleCallback(callback, options);
    } else {
      return setTimeout(callback, options.timeout || 1);
    }
  },
  
  // Intersection Observer con fallback
  createIntersectionObserver: function(callback, options = {}) {
    if ('IntersectionObserver' in window) {
      return new IntersectionObserver(callback, {
        rootMargin: options.rootMargin || '50px',
        threshold: options.threshold || 0.1
      });
    } else {
      // Fallback per browser non supportati
      return {
        observe: () => {},
        unobserve: () => {},
        disconnect: () => {}
      };
    }
  },
  
  // Memory cleanup
  cleanup: function() {
    if (window.PerformanceConfig.memory.enableGarbageCollection) {
      // Forza garbage collection se disponibile
      if (window.gc) {
        window.gc();
      }
    }
  }
};

// Inizializza le ottimizzazioni
document.addEventListener('DOMContentLoaded', function() {
  if (window.PerformanceConfig.monitoring.enabled) {
    console.log('[Performance] 🚀 Ottimizzazioni attivate');
    console.log('[Performance] 📊 Configurazione:', window.PerformanceConfig);
  }
  
  // Cleanup periodico della memoria
  if (window.PerformanceConfig.memory.cleanupInterval > 0) {
    setInterval(() => {
      window.PerformanceUtils.cleanup();
    }, window.PerformanceConfig.memory.cleanupInterval);
  }
});
